import { Flex, Text } from '@chakra-ui/react'
import { FileText, Voicemail } from 'lucide-react'
import React, { useMemo } from 'react'
import { QuickActionButtonVariants } from '~/components/shared/componentStyles/QuickActionButton.style'
import { CustomTooltipActionButton } from '~/components/shared/CustomTooltip/CustomTooltipActionButton'
import { CallSentimentTooltip } from '~/pages/Calls/CallSentimentTooltip'
import { useDurationCellStyles } from '~/pages/Calls/componentStyles/CallsListItem.style'
import { Size } from '~/types/ThemeTypes'
import { tripLeadingZeroFromTime } from '~/utils/formatter'

import { BouncingEllipsis } from '../CallDetails/BouncingEllipsis'
import { VoicemailToolTip } from '../CallDetails/VoicemailToolTip'

interface DurationCellProps {
  columnStyles: Record<string, any>
  duration: string
  hasVoicemail?: boolean
  callId: number
  pbxId: number
  transcriptId?: number
  customerSentimentScore?: number
  tableSize: Size
  onTranscriptClick?: () => void
  onVoicemailClick?: () => void
  voicemailId?: number
  isCallInProgress?: boolean
}
export const DurationCell = ({
  columnStyles,
  duration,
  hasVoicemail,
  callId,
  pbxId,
  transcriptId,
  onTranscriptClick,
  onVoicemailClick,
  customerSentimentScore,
  tableSize,
  voicemailId,
  isCallInProgress,
}: DurationCellProps) => {
  const styles = useDurationCellStyles()

  const isTranscriptSentimentNegative = !!(
    customerSentimentScore && customerSentimentScore <= -1
  )

  const trimmedDuration = useMemo(() => {
    return tripLeadingZeroFromTime(duration)
  }, [duration])

  const displayDuration = isCallInProgress ? (
    <BouncingEllipsis />
  ) : (
    <Text css={styles.text}>{trimmedDuration}</Text>
  )

  return (
    <Flex role="cell" css={{ ...columnStyles, ...styles.container }}>
      <Flex css={styles.wrapper}>
        <div>{displayDuration}</div>
        {tableSize == Size.sm && (
          <Flex css={styles.iconWrapper}>
            {!!transcriptId && (
              <CustomTooltipActionButton
                icon={FileText}
                variant={
                  isTranscriptSentimentNegative
                    ? QuickActionButtonVariants.Destructive_100
                    : QuickActionButtonVariants.Default_100
                }
                size={Size.sm}
                tooltipText=""
                onButtonClick={onTranscriptClick}
                popoverContents={
                  transcriptId && (
                    <CallSentimentTooltip
                      pbxId={pbxId}
                      callId={callId}
                      callerSentiment={1}
                      officeSentiment={-1}
                    />
                  )
                }
              />
            )}
            {hasVoicemail && (
              <CustomTooltipActionButton
                icon={Voicemail}
                variant={QuickActionButtonVariants.Default_100}
                size={Size.sm}
                tooltipText=""
                popoverContents={
                  hasVoicemail && (
                    <VoicemailToolTip
                      voicemailId={voicemailId ?? 0}
                      pbxId={pbxId}
                      callId={callId}
                    />
                  )
                }
                onButtonClick={onVoicemailClick}
              />
            )}
          </Flex>
        )}
      </Flex>
    </Flex>
  )
}
